import { useNumberFormatter } from '@mint-lib/formatting-hooks';
import { typographyVariants } from '@mint-lib/tw-components';
import type { TooltipPayload } from 'recharts';

import { formatChartValue, formatLabel } from '../../../helpers/charts.js';
import ChartTooltip from '../ChartTooltip/ChartTooltip.jsx';

type TooltipProps = {
  isActive: boolean;
  contentData: TooltipPayload | undefined;
  xValue: string;
};

const LinePlotTooltip = ({ isActive, contentData, xValue }: TooltipProps) => {
  const numberFormatter = useNumberFormatter();

  if (!isActive || !contentData?.length) {
    return null;
  }

  const x = contentData[0].payload[xValue];

  return (
    <ChartTooltip>
      <p
        className={typographyVariants({
          variant: 'caption2',
        })}
      >
        {formatLabel({
          label: xValue,
        })}
        : {x}
      </p>

      {contentData.map((data) => (
        <div className="flex flex-row gap-2" key={data.name}>
          <div
            style={{ backgroundColor: data.color }}
            className="h-7 w-1 items-center"
          />
          <div className="flex flex-col">
            <p
              className={typographyVariants({
                variant: 'bodyShort01',
              })}
            >
              {formatChartValue({ value: data.value, numberFormatter })}
            </p>
            <p
              className={typographyVariants({
                variant: 'label01',
              })}
            >
              {typeof data.name === 'string'
                ? formatLabel({
                    label: data.name,
                  })
                : data.name}
            </p>
          </div>
        </div>
      ))}
    </ChartTooltip>
  );
};

export default LinePlotTooltip;
